import { render, staticRenderFns } from "./package-images.vue?vue&type=template&id=3dae8cbc&scoped=true&"
import script from "./package-images.vue?vue&type=script&lang=js&"
export * from "./package-images.vue?vue&type=script&lang=js&"
import style0 from "./package-images.vue?vue&type=style&index=0&id=3dae8cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae8cbc",
  null
  
)

export default component.exports